<template>
  <div class="background" style="padding-bottom: 80px; color: white;">
    <BannerAula :titulo="titulo" :numero="numero" :titleSize="titleSize" />

    <v-container class="container px-5">
      <slot></slot>
    </v-container>

  </div>
</template>

<script>
import BannerAula from "@/components/BannerAula.vue";

export default {
  components: { BannerAula },

  props: ["titulo", "numero", "titleSize"],

  data() {
    return {};
  },
};
</script>

<style scoped>
.container {
  display: flex;
  flex-direction: column;
  gap: 50px;
  max-width: 1200px;
}
</style>
